import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { NavLink } from 'react-router-dom';

export default class MyInvoice extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'myinvoice',
            id: props.Id,
            isNew: props.IsNew,
            ins: props.Ins,
            inp: props.Inp,
            data: null,
            loading: true,
            bodyVersion: '',
            paymentVeriosn: '',
            t_am: 0,
            t_nw: 0,
            t_fee: 0,
            t_prdis: 0,
            t_dis: 0,
            t_adis: 0,
            t_vam: 0,
            t_tsstam: 0,
            t_pv: 0
        };
    }
    componentDidMount() {
        this.httpPost("api/v1/myinvoice/get", {
            id: this.getCurrentFormId(),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                window.companyId = data.global.company.id;
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    getBodyFooterSpanCount() {
        if (this.state.data.record.inp === 1) return 8;
        if (this.state.data.record.inp === 2) return 11;
        if (this.state.data.record.inp === 3) return 12;
        if (this.state.data.record.inp === 4) return 7;
        if (this.state.data.record.inp === 5) return 10;
        if (this.state.data.record.inp === 6) return 8;
        if (this.state.data.record.inp === 7) return 10;
        return 0;
    }
    renderForm() {
        return (
            <form onSubmit={e => this.save(e)} className="row g-4">
                <div className="nk-block-head">
                    <div className="nk-block-between g-3">
                        <div className="nk-block-head-content">
                            <h3 className="nk-block-title page-title">شماره مالیاتی: <strong className="text-primary small">{this.state.data.record.taxId}</strong></h3>
                            <div className="nk-block-des text-soft">
                                <ul className="list-inline">
                                    <li><span className="text-base">صورتحساب {this.state.data.record.insString} {this.state.data.record.inpString} نوع {this.state.data.record.intyString}</span></li>
                                </ul>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <NavLink to="/myinvoices/" className="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em className="icon ni ni-arrow-left"></em><span>برگشت</span></NavLink>
                            <NavLink to="/myinvoices" className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"><em className="icon ni ni-arrow-left"></em></NavLink>
                            {this.state.data.record.id > 0 && <a onClick={e => this.getPdf(e)} className="btn btn-white btn-outline-light"><em class="icon ni ni-file-pdf"></em><span>خروجی PDF</span></a>}
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="invoice">
                        <div className="invoice-action">
                            <a className="btn btn-icon btn-lg btn-white btn-dim btn-outline-primary hand" target="_blank"><em className="icon ni ni-printer-fill"></em></a>
                        </div>
                        <div className="invoice-wrap">
                            <div className="invoice-brand text-center">
                                <img src="/assets/images/logo-dark.webp" alt="" />
                            </div>
                            <div className="invoice-head">
                                <div className="invoice-contact">
                                    <span className="overline-title">خریدار</span>
                                    <div className="invoice-contact-info">
                                        <h4 className="title">{this.state.data.record.customerName}</h4>
                                        <ul className="list-plain">
                                            <li><em className="icon ni ni-map-pin-fill"></em><span>{this.state.data.record.customerAddress}</span></li>
                                            <li><em className="icon ni ni-call-fill"></em><span>{this.state.data.record.customerNationalId}</span></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="invoice-desc">
                                    <h3 className="title">{this.state.data.record.setmString}</h3>
                                    <ul className="list-plain">
                                        <li className="invoice-id"><span>سریال: {this.state.data.record.inno}</span></li>
                                        <li className="invoice-date"><span>تاریخ: {this.state.data.record.indatimPersian}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="invoice-bills">
                                <div className="table-responsive">
                                    <table className="table table-striped">
                                        <thead>
                                            <tr>
                                                <th>ردیف</th>
                                                <th>شرح کالا/خدمات</th>
                                                <th>واحد</th>
                                                <th>تعداد/مقدار</th>
                                                {this.state.data.record.inp === 7 && <th>وزن خالص</th>}
                                                <th>مبلغ واحد</th>

                                                {this.state.data.record.inp === 2 && <th>میزان ارز</th>}

                                                {(this.state.data.record.inp === 7 || this.state.data.record.inp === 2) && <th>نوع ارز</th>}
                                                {(this.state.data.record.inp === 7 || this.state.data.record.inp === 2) && <th>نرخ برابری ارز و ریال</th>}

                                                {this.state.data.record.inp === 7 && <th>ارزش ریالی کالا</th>}
                                                {this.state.data.record.inp === 7 && <th>ارزش ارزی کالا</th>}

                                                {this.state.data.record.inp !== 7 && <th>مبلغ قبل تخفیف</th>}
                                                {this.state.data.record.inp !== 7 && <th>تخفیف</th>}
                                                {this.state.data.record.inp !== 7 && <th>مبلغ بعد تخفیف</th>}

                                                <th>نرخ مالیات</th>
                                                <th>مالیات</th>

                                                {this.state.data.record.inp === 5 && <th>موضوع سایر مالیات</th>}
                                                {this.state.data.record.inp === 5 && <th>نرخ سایر مالیات</th>}
                                                {this.state.data.record.inp === 5 && <th>مبلغ سایر مالیات</th>}

                                                {this.state.data.record.inp === 3 && <th>اجرت ساخت</th>}
                                                {this.state.data.record.inp === 3 && <th>سود فروشنده</th>}
                                                {this.state.data.record.inp === 3 && <th>حق العمل</th>}
                                                {this.state.data.record.inp === 3 && <th>جمع کل اجرت، حق العمل و سود</th>}

                                                <th>جمع کل</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.data.bodies.map((body,index)=>
                                                <tr>
                                                    <td>{index+1}</td>
                                                    <td>{body.stuffName} - {body.stuffTaxNumber}</td>
                                                    <td>{body.unitName}</td>
                                                    <td>{this.money(body.am)}</td>
                                                    {this.state.data.record.inp === 7 && <td>{this.money(body.nw)}</td>}
                                                    <td>{this.money(body.fee)}</td>

                                                    {this.state.data.record.inp === 2 && <td>{body.cfee}</td>}

                                                    {(this.state.data.record.inp === 7 || this.state.data.record.inp === 2) && <td>{body.cut}</td>}
                                                    {(this.state.data.record.inp === 7 || this.state.data.record.inp === 2) && <td>{body.exr}</td>}

                                                    {this.state.data.record.inp === 7 && <td>{this.money(body.ssrv)}</td>}
                                                    {this.state.data.record.inp === 7 && <td>{this.money(body.sscv)}</td>}

                                                    {this.state.data.record.inp !== 7 && <td>{this.money(body.prdis)}</td>}
                                                    {this.state.data.record.inp !== 7 && <td>{this.money(body.dis)}</td>}
                                                    {this.state.data.record.inp !== 7 && <td>{this.money(body.adis)}</td>}

                                                    <td>{body.vra}</td>
                                                    <td>{this.money(body.vam)}</td>

                                                    {this.state.data.record.inp === 5 && <td>{body.odt}</td>}
                                                    {this.state.data.record.inp === 5 && <td>{body.odr}</td>}
                                                    {this.state.data.record.inp === 5 && <td>{this.money(body.odam)}</td>}

                                                    {this.state.data.record.inp === 3 && <td>{body.consfee}</td>}
                                                    {this.state.data.record.inp === 3 && <td>{body.spro}</td>}
                                                    {this.state.data.record.inp === 3 && <td>{body.bros}</td>}
                                                    {this.state.data.record.inp === 3 && <td>{body.tcpbs}</td>}

                                                    <td>{this.money(body.tsstam)}</td>
                                                </tr>
                                            )}
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td colspan={this.getBodyFooterSpanCount()}></td>
                                                <td colspan="2">مجموع قبل از تخفیف</td>
                                                <td>{this.money(this.state.data.record.tprdis)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan={this.getBodyFooterSpanCount()}></td>
                                                <td colspan="2">مجموعه تخفیفات</td>
                                                <td>{this.money(this.state.data.record.tdis)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan={this.getBodyFooterSpanCount()}></td>
                                                <td colspan="2">مجموع بعد از تخفیف</td>
                                                <td>{this.money(this.state.data.record.tadis)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan={this.getBodyFooterSpanCount()}></td>
                                                <td colspan="2">مجموع مالیات</td>
                                                <td>{this.money(this.state.data.record.tvam)}</td>
                                            </tr>
                                            <tr>
                                                <td colspan={this.getBodyFooterSpanCount()}></td>
                                                <td colspan="2">جمع کل صورتحساب</td>
                                                <td>{this.money(this.state.data.record.tbill)}</td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />
            ];

        return contents;
    }
}